<template>
  <div>
    <b-row>
      <b-col cols="12" class="text-right">
        <b-button
          @click="$router.push('/promotions/deposit-match')"
          variant="outline-secondary"
          class="mr-1"
        >
          Cancel
        </b-button>
        <b-button
          @click="
            handleCreatePromotion({ status: 'inactive', action: 'draft' })
          "
          variant="outline-secondary"
          class="mr-1"
          :disabled="loadingAction === 'draft' && loadingCreatePromotion"
          style="min-width: 136px"
        >
          Save as Draft
        </b-button>

        <b-button
          :disabled="loadingAction === 'publish' && loadingCreatePromotion"
          @click="
            handleCreatePromotion({ status: 'active', action: 'publish' })
          "
          variant="primary"
          style="min-width: 172px"
          class="mr-1"
        >
          Publish Promotion
        </b-button>
        <b-button
          :disabled="loadingAction === 'now' && loadingCreatePromotion"
          @click="
            handleCreatePromotion({
              status: 'active',
              isNow: true,
              action: 'now',
            })
          "
          variant="primary"
          style="min-width: 172px"
        >
          Publish Promotion Now
        </b-button>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <validation-observer ref="validateDepositMatchForm">
        <b-col cols="12">
          <b-card>
            <b-row>
              <b-col cols="12">
                <b-form-group
                  class="font-weight-bold"
                  label="Promotion Name (Internal Description)"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="name"
                    rules="required"
                  >
                    <b-form-input
                      placeholder="June 100% Deposit Bonus"
                      v-model="form.name"
                      type="text"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mt-1">
              <b-col cols="12">
                <p class="font-weight-bold mb-0">
                  Promotion Description (Customer Description)
                </p>
                <b-form-textarea
                  v-model="form.description"
                  placeholder="Get a 100% match when you deposit up to $500 for a limited time!"
                  rows="1"
                  no-resize
                ></b-form-textarea>
              </b-col>
            </b-row>

            <b-row class="mt-1">
              <b-col cols="12">
                <p class="font-weight-bold mb-0">More Info</p>
                <vue2-tinymce-editor
                  :key="'additionalInfo'"
                  id="additionalInfo"
                  v-model="form.additionalInfo"
                  :options="{ ...editorOptions }"
                />
              </b-col>
            </b-row>

            <b-row class="mt-1">
              <b-col cols="6">
                <b-row>
                  <b-col cols="6">
                    <p class="font-weight-bold mb-0">Start Date / Time</p>
                    <flat-pickr
                      id="startDate"
                      v-model="form.openDate"
                      class="form-control"
                      :config="configDate"
                      placeholder="dd/mm/yyyy hh:mm"
                    />
                  </b-col>
                  <b-col cols="6">
                    <p class="font-weight-bold mb-0">End Date / Time</p>
                    <flat-pickr
                      id="endDate"
                      v-model="form.closeDate"
                      class="form-control"
                      :config="configDate"
                      placeholder="dd/mm/yyyy hh:mm"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>

          <b-row>
            <b-col cols="12">
              <b-card>
                <h4 class="font-weight-bolder text-body mb-0 text-nowrap">
                  Match Percentage Configuration
                </h4>
                <b-row>
                  <b-col cols="12" md="6">
                    <p class="font-weight-bold mb-0">Match Percentage*</p>
                    <b-input-group size="md" append="%">
                      <b-form-input
                        v-model="form.discountValue"
                        value="20"
                        min="1"
                      ></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <p class="font-weight-bold mb-0">Maximum Match Amount*</p>
                    <b-input-group size="md" prepend="$">
                      <b-form-input
                        v-model="form.maxDiscount"
                        value="500"
                        min="1"
                      ></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>

                <b-card body-class="rounded bg-light" class="mt-2 mb-0">
                  <div class="d-flex">
                    <feather-icon icon="InfoIcon" size="17" />
                    <p
                      class="font-weight-bolder mb-0"
                      style="font-size: 16px; margin-left: 4px"
                    >
                      Bonus Calculator
                    </p>
                  </div>
                  <span class="text-muted">
                    Based on your configuration, here's how the bonus would
                    work:
                  </span>

                  <b-row class="mt-1">
                    <b-col cols="12">
                      <b-row>
                        <b-col cols="12" md="4">
                          <b-card class="mb-0" border-variant="secondary">
                            <p class="mb-0">If customer deposits:</p>
                            <p class="font-weight-bolder">$20</p>
                            <p class="mb-0">Bonus amount:</p>
                            <p class="font-weight-bolder text-primary">
                              {{
                                form.discountValue &&
                                Number(form.discountValue) > 0 &&
                                !!form.maxDiscount
                                  ? (form.discountValue * 20) / 100 >
                                    form.maxDiscount
                                    ? "$" + form.maxDiscount + " (max)"
                                    : "$" +
                                      ((form.discountValue * 20) / 100).toFixed(
                                        2
                                      )
                                  : "-"
                              }}
                            </p>
                          </b-card>
                        </b-col>
                        <b-col cols="12" md="4">
                          <b-card class="mb-0" border-variant="secondary">
                            <p class="mb-0">If customer deposits:</p>
                            <p class="font-weight-bolder">$260</p>
                            <p class="mb-0">Bonus amount:</p>
                            <p class="font-weight-bolder text-primary">
                              {{
                                form.discountValue &&
                                Number(form.discountValue) > 0 &&
                                !!form.maxDiscount
                                  ? (form.discountValue * 260) / 100 >
                                    form.maxDiscount
                                    ? "$" + form.maxDiscount + " (max)"
                                    : "$" +
                                      (
                                        (form.discountValue * 260) /
                                        100
                                      ).toFixed(2)
                                  : "-"
                              }}
                            </p>
                          </b-card>
                        </b-col>
                        <b-col cols="12" md="4">
                          <b-card class="mb-0" border-variant="secondary">
                            <p class="mb-0">If customer deposits:</p>
                            <p class="font-weight-bolder">$1000</p>
                            <p class="mb-0">Bonus amount:</p>
                            <p class="font-weight-bolder text-primary">
                              {{
                                form.discountValue &&
                                Number(form.discountValue) > 0 &&
                                !!form.maxDiscount
                                  ? (form.discountValue * 1000) / 100 >
                                    form.maxDiscount
                                    ? "$" + form.maxDiscount + " (max)"
                                    : "$" +
                                      (
                                        (form.discountValue * 1000) /
                                        100
                                      ).toFixed(2)
                                  : "-"
                              }}
                            </p>
                          </b-card>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card>

                <b-row class="mt-1">
                  <b-col cols="12" md="6">
                    <p class="font-weight-bold mb-0">Accumulator</p>
                    <v-select
                      v-model="form.subType"
                      :options="optionsType"
                      :reduce="(val) => val.value"
                      :clearable="false"
                      @input="(val) => (option = val.value)"
                      class="w-100"
                      disabled
                    />
                  </b-col>
                  <b-col cols="12" md="6">
                    <p class="font-weight-bold mb-0">
                      How Many Days for the Bonus Bets left to expire
                    </p>
                    <b-form-input
                      type="number"
                      v-model.number="form.bonusExpiredDays"
                      :min="1"
                      :step="1"
                      disabled
                    />
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-card>
                <b-row>
                  <b-col
                    cols="12"
                    class="d-flex align-items-center justify-content-between mb-1"
                    ><h5 class="font-weight-bolder text-body">
                      Customer Eligibility
                    </h5>
                    <input
                      ref="fileInput"
                      type="file"
                      accept=".csv"
                      hidden
                      @change="handleFileUpload"
                    />
                    <b-button
                      size="sm"
                      variant="outline-primary"
                      @click="onClickInput"
                    >
                      <feather-icon icon="UploadIcon" />

                      CSV File Upload
                    </b-button>
                  </b-col>
                  <b-col cols="12">
                    <div>
                      <div
                        class="d-flex align-items-center mb-1 cursor-pointer"
                        style="border-bottom: 1px solid #dee2e6"
                      >
                        <div
                          @click="activeTabCustomer = 'Customer Profiles'"
                          style="padding: 6px 16px"
                          :class="{
                            'active-tab':
                              activeTabCustomer === 'Customer Profiles',
                          }"
                        >
                          Customer Profiles
                        </div>
                        <div
                          style="
                            padding: 6px 16px;
                            opacity: 0.45;
                            cursor: default;
                            user-select: none;
                          "
                          :class="{
                            'active-tab':
                              activeTabCustomer === 'Customer Segments',
                          }"
                        >
                          Customer Segments
                        </div>
                      </div>

                      <b-row>
                        <b-col style="min-height: 100px">
                          <!-- Customer Profiles -->
                          <div
                            v-if="activeTabCustomer === 'Customer Profiles'"
                            class="grid-3"
                          >
                            <div
                              class="d-flex align-items-center cursor-pointer"
                              v-for="item in profiles"
                              :key="item"
                              style="
                                border: 1px solid #dee2e6;
                                border-radius: 5px;
                                gap: 10px;
                                padding: 8px 10px;
                              "
                              :style="{
                                background: selectedProfile.some(
                                  (i) => i === item
                                )
                                  ? '#0D6EFD'
                                  : '#f8f9fa',
                                color: selectedProfile.some((i) => i === item)
                                  ? 'white'
                                  : 'black',
                              }"
                              @click="handleSelectProfile(item)"
                            >
                              <div
                                class="d-flex justify-content-center align-items-center"
                                style="
                                  width: 16px;
                                  height: 16px;
                                  border-radius: 2px;
                                  border: 1px solid #dee2e6;
                                "
                                :style="{
                                  background: selectedProfile.some(
                                    (i) => i === item
                                  )
                                    ? '#0D6EFD'
                                    : 'white',
                                }"
                              >
                                <feather-icon
                                  icon="CheckIcon"
                                  style="color: white"
                                />
                              </div>
                              {{ item }}
                            </div>
                          </div>

                          <!-- Customer Segments -->
                          <div
                            v-else
                            style="
                              opacity: 0.45;
                              pointer-events: none;
                              user-select: none;
                            "
                          >
                            <draggable
                              :list="customerSegments"
                              :group="{
                                name: 'tag',
                                pull: 'clone',
                                put: false,
                              }"
                              @change="handleDrag"
                              class="d-flex flex-wrap w-100"
                              :sort="false"
                            >
                              <b-col
                                v-for="(tag, index) in customerSegments"
                                :key="index"
                                cols="6"
                                md="3"
                                style="padding: 6px"
                              >
                                <b-card
                                  border-variant="secondary"
                                  body-class="p-0"
                                  class="mb-0"
                                  style="padding: 8px; border-radius: 4px"
                                  :data-item="JSON.stringify(tag)"
                                  ><span>{{ tag.name }}</span></b-card
                                >
                              </b-col>
                            </draggable>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>

                <!-- Customer Picker Section -->
                <b-row class="mt-2">
                  <b-col cols="12" class="mb-1">
                    <h5 class="font-weight-bolder text-body">Customers</h5>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-card no-body class="border" style="overflow: hidden">
                      <!-- Sticky Search -->
                      <div
                        class="p-1"
                        style="
                          border-bottom: 1px solid #e0e0e0;
                          position: sticky;
                          top: 0;
                          z-index: 2;
                          background: white;
                        "
                      >
                        <b-form-input
                          v-model="userPickerSearch"
                          placeholder="Search by username..."
                        />
                      </div>
                      <!-- Scrollable User List -->
                      <div
                        ref="userPickerList"
                        style="max-height: 320px; overflow-y: auto"
                        @scroll="handleUserListScroll"
                      >
                        <div
                          v-if="
                            userPickerLoading && userPickerUsers.length === 0
                          "
                          class="text-center py-3 text-muted"
                        >
                          <b-spinner small /> Loading...
                        </div>
                        <div
                          v-else-if="
                            !userPickerLoading && userPickerUsers.length === 0
                          "
                          class="text-center py-3 text-muted"
                        >
                          No users found
                        </div>
                        <div
                          v-for="user in userPickerUsers"
                          :key="user.userId"
                          class="d-flex align-items-center px-2 py-1"
                          style="
                            border-bottom: 1px solid #f0f0f0;
                            cursor: pointer;
                            transition: background 0.15s;
                          "
                          :style="
                            isUserConfirmed(user.userId)
                              ? 'background:#f0fff4'
                              : userPickerVerifyingId === user.userId
                              ? 'background:#f8f9fa'
                              : ''
                          "
                          @click="handleSelectUser(user)"
                        >
                          <b-avatar
                            size="28"
                            :text="
                              (user.firstName ||
                                user.username ||
                                '?')[0].toUpperCase()
                            "
                            variant="light-primary"
                            class="mr-1"
                          />
                          <div style="flex: 1; min-width: 0">
                            <div
                              class="font-weight-bold text-truncate"
                              style="font-size: 13px"
                            >
                              {{ user.firstName }} {{ user.lastName }}
                            </div>
                            <div
                              class="text-muted text-truncate"
                              style="font-size: 11px"
                            >
                              {{ user.username }} &bull; {{ user.userId }}
                            </div>
                          </div>
                          <b-spinner
                            v-if="userPickerVerifyingId === user.userId"
                            small
                            class="ml-1"
                          />
                          <feather-icon
                            v-else-if="isUserConfirmed(user.userId)"
                            icon="CheckIcon"
                            size="16"
                            class="ml-1"
                            style="color: #28a745; flex-shrink: 0"
                          />
                        </div>
                        <div
                          v-if="userPickerLoading && userPickerUsers.length > 0"
                          class="text-center py-2 text-muted"
                        >
                          <b-spinner small /> Loading more...
                        </div>
                      </div>
                    </b-card>
                  </b-col>

                  <!-- Confirmed Users List -->
                  <b-col cols="12" md="6">
                    <b-card
                      no-body
                      class="border"
                      style="overflow: hidden; min-height: 60px"
                    >
                      <div style="max-height: 362px; overflow-y: auto">
                        <div
                          v-if="confirmedUsers.length === 0"
                          class="text-center text-muted py-3"
                          style="font-size: 13px"
                        >
                          No users selected yet.
                        </div>
                        <div
                          v-for="(u, idx) in confirmedUsers"
                          :key="u.userId"
                          class="d-flex align-items-center px-2 py-1"
                          style="
                            border-bottom: 1px solid #cce5ff;
                            background: #e8f4ff;
                          "
                        >
                          <b-avatar
                            size="28"
                            :text="
                              (u.firstName ||
                                u.username ||
                                '?')[0].toUpperCase()
                            "
                            variant="light-primary"
                            class="mr-1"
                          />
                          <div style="flex: 1; min-width: 0">
                            <div
                              class="font-weight-bold text-truncate"
                              style="font-size: 13px"
                            >
                              {{ u.firstName }} {{ u.lastName }}
                            </div>
                            <div
                              class="text-muted text-truncate"
                              style="font-size: 11px"
                            >
                              {{ u.username }} &bull; {{ u.userId }}
                            </div>
                          </div>
                          <b-button
                            size="sm"
                            variant="flat-danger"
                            class="p-0 ml-1"
                            style="line-height: 1; min-width: 24px"
                            @click="removeConfirmedUser(idx)"
                          >
                            <feather-icon icon="XIcon" size="14" />
                          </b-button>
                        </div>
                      </div>
                    </b-card>
                    <div class="mt-1 mb-1 text-right">
                      <b-button
                        size="sm"
                        variant="outline-primary"
                        :disabled="confirmedUsers.length === 0"
                        @click="handleAddConfirmedUsersToSegment"
                      >
                        <feather-icon
                          icon="ArrowRightIcon"
                          size="14"
                          class="mr-25"
                        />
                        Set Recurrence List Selected
                      </b-button>
                    </div>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12" class="mt-1" style="margin-bottom: 5px">
                    <!-- <small class="text-muted text-sm"
                          >Drag items to the table on the right to set
                          recurring issuance</small
                        > -->
                  </b-col>
                  <b-col>
                    <draggable
                      :value="selectedSegment"
                      @change="handleDrag"
                      @add="handleDrop"
                      group="tag"
                      class="w-100"
                    >
                      <div
                        style="border: 1px solid #dee2e6; border-radius: 5px"
                      >
                        <p
                          style="
                            background: #f8f9fa;
                            font-weight: 800;
                            border-radius: 5px 5px 0 0;
                            padding: 8px 10px;
                            border-bottom: 1px solid #dee2e6;
                          "
                        >
                          Segment
                        </p>

                        <div
                          v-if="selectedSegment.length === 0"
                          class="d-flex align-items-center justify-content-center"
                          style="min-height: 100px"
                        >
                          <div>
                            Drag profiles or segments here to include in this
                            promotion
                          </div>
                        </div>
                        <div v-else>
                          <div
                            v-for="(item, ind) in selectedSegment"
                            :key="ind"
                            class="d-flex justify-content-between"
                            style="
                              border-bottom: 1px solid #dee2e6;
                              padding: 6px 16px;
                            "
                          >
                            <div class="d-flex flex-column">
                              <span style="font-weight: 800">{{
                                item.name
                              }}</span>
                              <span
                                style="font-size: 12px"
                                v-if="item.selectedUsers"
                                >{{ item.selectedUsers.length }} customers from
                                CSV</span
                              >
                            </div>
                            <b-button
                              size="sm"
                              variant="outline-danger"
                              @click="deleteSegmentItem(item)"
                              style="height: 29px !important"
                            >
                              Remove
                            </b-button>
                          </div>
                        </div>
                      </div>
                    </draggable>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-card>
                <h5 class="font-weight-bold mb-0">Marketing Assets</h5>
                <div class="mt-1">
                  <b-tabs pills>
                    <b-tab active>
                      <template #title>
                        <span
                          class="d-flex align-items-center"
                          style="gap: 6px"
                        >
                          Banner
                          <feather-icon
                            :icon="
                              isBannerComplete
                                ? 'CheckCircleIcon'
                                : 'XCircleIcon'
                            "
                            size="16"
                            :class="
                              isBannerComplete ? 'text-success' : 'text-danger'
                            "
                          />
                        </span>
                      </template>
                      <b-row>
                        <b-col
                          md="3"
                          sm="6"
                          v-for="banner in banners"
                          :key="banner.key"
                        >
                          <b-form-group>
                            <p class="font-weight-bold mb-0">
                              {{ banner.label }}
                            </p>

                            <!-- File input -->
                            <b-form-file
                              v-model="banner.file"
                              accept="image/*"
                              @input="onFileChange(banner)"
                              placeholder="Choose File"
                              browse-text="Choose File"
                            ></b-form-file>

                            <small class="text-muted d-block mt-1">{{
                              banner.desc
                            }}</small>

                            <!-- Preview + Loading -->
                            <b-skeleton
                              v-if="banner.loading"
                              class="skeleton-box mx-auto rounded border"
                              style="width: 100%; min-height: 150px"
                            ></b-skeleton>

                            <img
                              v-else-if="
                                banner.previewUrl &&
                                formBanner.bannerPosition === banner.key
                              "
                              :src="banner.previewUrl"
                              alt="preview"
                              class="img-fluid rounded border"
                              style="
                                width: 100%;
                                min-width: 100%;
                                min-height: 150px;
                                height: 150px;
                                object-fit: cover;
                              "
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <validation-provider
                            #default="{ errors }"
                            name="banner link"
                            :rules="
                              formBanner.bannerPosition ? 'required' : undefined
                            "
                          >
                            <b-form-group
                              label="Banner Link URL"
                              label-class="font-weight-bold"
                            >
                              <b-form-input
                                v-model="formBanner.bannerLink"
                                placeholder="https://example.com/promotion"
                              ></b-form-input>
                              <div>
                                <small class="text-danger">{{
                                  errors[0]
                                }}</small>
                              </div>
                              <small class="text-muted"
                                >Where should users go when they click the
                                banner?</small
                              >
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12">
                          <b-row>
                            <b-col cols="3">
                              <validation-provider
                                #default="{ errors }"
                                name="start date"
                                :rules="
                                  formBanner.bannerPosition
                                    ? 'required'
                                    : undefined
                                "
                              >
                                <b-form-group label="Start Date">
                                  <flat-pickr
                                    :value="formBanner.startDate"
                                    class="form-control"
                                    :config="configDateBanner"
                                    placeholder="dd/mm/yyyy"
                                    @input="
                                      (val) => (formBanner.startDate = val)
                                    "
                                  />
                                  <small class="text-danger">{{
                                    errors[0]
                                  }}</small>
                                </b-form-group>
                              </validation-provider>
                            </b-col>
                            <b-col cols="3">
                              <validation-provider
                                #default="{ errors }"
                                name="end date"
                                :rules="
                                  formBanner.bannerPosition
                                    ? 'required'
                                    : undefined
                                "
                              >
                                <b-form-group label="End Date">
                                  <flat-pickr
                                    :value="formBanner.endDate"
                                    class="form-control"
                                    :config="configDateBanner"
                                    placeholder="dd/mm/yyyy"
                                    @input="(val) => (formBanner.endDate = val)"
                                  />
                                  <small class="text-danger">{{
                                    errors[0]
                                  }}</small>
                                </b-form-group>
                              </validation-provider>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>

                      <b-row class="mt-1"
                        ><b-col>
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <h6 class="font-weight-bold mb-0">
                              Desktop Preview
                            </h6>
                          </div>
                          <div class="mt-2">
                            <DesktopUI
                              :banners="banners"
                              :bannerPosition="formBanner.bannerPosition"
                            />
                          </div> </b-col
                      ></b-row>

                      <b-row class="mt-1">
                        <b-col cols="12">
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <h6 class="font-weight-bold mb-0">
                              Mobile Preview
                            </h6>
                          </div>
                          <div class="mt-1">
                            <MobileUI :bannerCarousel="banners[0]" />
                          </div>
                        </b-col>
                      </b-row>
                    </b-tab>

                    <!-- INAPP TAB -->
                    <b-tab title="INAPP">
                      <p class="text-muted">INAPP configuration here</p>
                    </b-tab>

                    <!-- EMAIL TAB -->
                    <b-tab title="Email">
                      <p class="text-muted">Email template configuration</p>
                    </b-tab>

                    <!-- SMS TAB -->
                    <b-tab title="SMS">
                      <p class="text-muted">SMS content configuration</p>
                    </b-tab>
                  </b-tabs>
                </div>
              </b-card>
            </b-col>
            <b-col cols="12">
              <b-card>
                <h5 class="font-weight-bold mb-0">
                  Terms & Conditions (Mandatory)
                </h5>
                <div class="mt-1">
                  <b-form-group label="Choose Template">
                    <b-form-select
                      v-model="form.templateId"
                      :options="templates"
                    ></b-form-select>
                  </b-form-group>
                  <b-form-group label="Terms Content">
                    <b-form-textarea
                      v-model="form.termFinalContent"
                      rows="4"
                    ></b-form-textarea>
                    <small
                      >You can edit the template text before publishing</small
                    >
                  </b-form-group>
                </div>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" class="text-right">
              <b-button
                @click="$router.push('/promotions/deposit-match')"
                variant="outline-secondary"
                class="mr-1"
              >
                Cancel
              </b-button>
              <b-button
                @click="
                  handleCreatePromotion({ status: 'inactive', action: 'draft' })
                "
                variant="outline-secondary"
                class="mr-1"
                :disabled="loadingAction === 'draft' && loadingCreatePromotion"
                style="min-width: 136px"
              >
                Save as Draft
              </b-button>

              <b-button
                :disabled="
                  loadingAction === 'publish' && loadingCreatePromotion
                "
                @click="
                  handleCreatePromotion({ status: 'active', action: 'publish' })
                "
                variant="primary"
                style="min-width: 172px"
                class="mr-1"
              >
                Publish Promotion
              </b-button>
              <b-button
                :disabled="loadingAction === 'now' && loadingCreatePromotion"
                @click="
                  handleCreatePromotion({
                    status: 'active',
                    isNow: true,
                    action: 'now',
                  })
                "
                variant="primary"
                style="min-width: 172px"
              >
                Publish Promotion Now
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </validation-observer>
    </b-row>
  </div>
</template>

<script>
import Spinner from "@core/components/Spinner";
import {
  BButton,
  BCard,
  BCol,
  BPagination,
  BRow,
  BButtonGroup,
  BTable,
  BCardBody,
  BFormInput,
  BMedia,
  BAvatar,
  BProgress,
  BProgressBar,
  BFormTextarea,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BImg,
  BFormCheckboxGroup,
  BFormSelect,
  BInputGroup,
  BFormFile,
  BSkeleton,
  BTabs,
  BTab,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import DualListbox from "../../components/DuoListBox.vue";
import { mapState, mapActions } from "vuex";
import useToastHandler from "@/services/toastHandler";
import { parse } from "csv-parse";
import draggable from "vuedraggable";
import { formatDateSend } from "@/helpers/utils";
import { v4 as uuidv4 } from "uuid";
import { Vue2TinymceEditor } from "vue2-tinymce-editor";
import MobileUI from "../../../marketing/BannerManagement/components/MobileUI.vue";
import DesktopUI from "../../../marketing/BannerManagement/components/DesktopUI.vue";
import { sanitizePayload } from "@/helpers/utils";

export default {
  components: {
    BButton,
    BCard,
    BRow,
    BCol,
    BTable,
    BMedia,
    BPagination,
    vSelect,
    Spinner,
    BButtonGroup,
    BTable,
    BCardBody,
    BFormInput,
    BAvatar,
    flatPickr,
    BProgress,
    BProgressBar,
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BImg,
    BFormCheckboxGroup,
    BFormSelect,
    BInputGroup,
    BFormFile,
    DualListbox,
    draggable,
    Vue2TinymceEditor,
    BSkeleton,
    MobileUI,
    DesktopUI,
    BTabs,
    BTab,
  },
  data() {
    const banners = [
      {
        key: "carousel",
        label: "Carousel Banner (Web & Mobile)",
        desc: "Inside website carousel - 1200x400px",
        width: 1200,
        height: 400,
        resourceId: null,
        previewUrl: null,
        loading: false,
      },
      {
        key: "top",
        label: "Top Banner",
        desc: "Full-width top banner - 1920x150px",
        width: 1920,
        height: 150,
        resourceId: null,
        previewUrl: null,
        loading: false,
      },
      {
        key: "left",
        label: "Left Sidebar Banner",
        desc: "Left side promotional banner - 220x600px",
        width: 220,
        height: 600,
        resourceId: null,
        previewUrl: null,
        loading: false,
      },
      {
        key: "right",
        label: "Right Sidebar Banner",
        desc: "Right side promotional banner - 300x600px",
        width: 300,
        height: 600,
        resourceId: null,
        previewUrl: null,
        loading: false,
      },
    ];
    return {
      form: {
        name: "",
        description: "",
        additionalInfo: "",
        openDate: new Date(),
        closeDate: "",
        bonusExpiredDays: null,
        type: "deposit",
        maxDiscount: "",
        discountValue: "",
        subType: "One-time Deposit",
        currentResource: null,
        termFinalContent: "",
        templateId: null,
      },
      max: 4,
      value: 2,
      configDate: {
        enableTime: true,
        altInput: true,
        altFormat: "d/m/Y H:i (AEDT)",
        dateFormat: "Y-m-d H:i:S",
        static: true,
      },
      selected: [],
      customerSegments: [],
      optionsType: [
        { label: "Yes - Accumulative", value: "Recurring Deposit" },
        { label: "No - Once Off Deposit", value: "One-time Deposit" },
      ],
      profiles: [],
      selectedProfile: [],
      activeTabCustomer: "Customer Profiles",
      selectedSegment: [],
      editorOptions: {
        forced_root_block: "div",
        height: 200,
        content_style: `
        html, body {
          background-color: #0766AA !important; 
          height: 100%;                         
          margin: 0;                        
          padding: 10px;               
          font-family: Arial, sans-serif;
          box-sizing: border-box;
        }
        
      `,
        forced_root_block_attrs: {
          style: "color: white;",
        },
      },
      banners,
      formBanner: {
        bannerLink: "",
        bannerPosition: "",
        startDate: "",
        endDate: "",
      },
      configDateBanner: {
        enableTime: true,
        noCalendar: false,
        time_24hr: true,
        altFormat: "d-m-Y H:i",
      },
      templates: [],
      loadingAction: null,
      // User Picker
      userPickerSearch: "",
      userPickerUsers: [],
      userPickerLoading: false,
      userPickerPage: 1,
      userPickerHasMore: true,
      userPickerVerifyingId: null,
      confirmedUsers: [],
    };
  },
  watch: {
    userPickerSearch: {
      handler() {
        clearTimeout(this._userPickerSearchTimer);
        this._userPickerSearchTimer = setTimeout(() => {
          this.handleUserPickerSearch();
        }, 300);
      },
    },
    termConditions(val) {
      if (!val) return;
      this.templates = val.map((i) => {
        return {
          ...i,
          value: i.id,
          text: i.name,
        };
      });
      const isUpdate = this.$router.currentRoute.params.id;
      if (!isUpdate) {
        this.form.templateId = this.templates[0].value;
        this.form.termFinalContent = this.templates[0].text;
      }
    },
    "form.templateId"(val) {
      const selectedTemplate = this.termConditions.find((i) => i.id === val);
      this.form.termFinalContent = selectedTemplate
        ? selectedTemplate.content
        : "";
    },
  },
  async created() {
    await Promise.all([
      this.fetchSegmentList(),
      this.fetchProfileList(),
      this.getTermConditions(),
      this.fetchMarketingDefaults(),
    ]);
    await this.fetchDetailPromotion();
    this.loadUserPickerPage();
  },
  computed: {
    ...mapState("user/list", ["tags"]),
    ...mapState("promotions/deposit-match-offer/create", ["loading"]),
    ...mapState("promotions/list", ["loadingCreatePromotion"]),
    ...mapState("promotions/price-promotions", ["termConditions"]),
    isBannerComplete() {
      return !!(
        this.formBanner.bannerPosition &&
        this.formBanner.bannerLink &&
        this.formBanner.startDate &&
        this.formBanner.endDate
      );
    },
  },
  methods: {
    ...mapActions({
      getSegmentsList: "segment/list/getSegmentsList",
      getProfileList: "user/list/getProfileList",
      createNewPromotion: "promotions/list/createNewPromotion",
      getDetailPromotion: "promotions/list/getDetailPromotion",
      deletePromotionTarget: "promotions/list/deletePromotionTarget",
      updatePromotionTargets: "promotions/list/updatePromotionTargets",
      updatePromotion: "promotions/list/updatePromotion",
      createUserList: "user/list/createUserList",
      getUserList: "user/list/getUserListByGroup",
      getTermConditions: "promotions/price-promotions/getTermConditions",
      uploadBannerImage: "marketing/banner/uploadBannerImage",
      getAllUserList: "user/list/getUserListBrief",
      verifyDepositMatchEligibility: "user/list/verifyDepositMatchEligibility",
      getMarketingPromoSettings:
        "settings/marketing-promo/getMarketingPromoSettings",
    }),
    async fetchMarketingDefaults() {
      const data = await this.getMarketingPromoSettings();
      if (data?.value != null) {
        this.form.bonusExpiredDays = data.value;
      }
    },
    // User Picker methods
    handleUserPickerSearch() {
      this.userPickerUsers = [];
      this.userPickerPage = 1;
      this.userPickerHasMore = true;
      this.loadUserPickerPage();
    },
    async loadUserPickerPage() {
      if (this.userPickerLoading || !this.userPickerHasMore) return;
      this.userPickerLoading = true;
      try {
        const limit = 20;
        const data = await this.getAllUserList({
          ...(this.userPickerSearch && { search: this.userPickerSearch || "" }),
          limit,
          page: this.userPickerPage,
        });
        if (!data || data.length === 0) {
          this.userPickerHasMore = false;
        } else {
          this.userPickerUsers = [...this.userPickerUsers, ...data];
          this.userPickerPage += 1;
          if (data.length < limit) this.userPickerHasMore = false;
        }
      } catch (e) {
        this.userPickerHasMore = false;
      } finally {
        this.userPickerLoading = false;
      }
    },
    handleUserListScroll(e) {
      const el = e.target;
      const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 60;
      if (nearBottom && this.userPickerHasMore && !this.userPickerLoading) {
        this.loadUserPickerPage();
      }
    },
    isUserConfirmed(userId) {
      return this.confirmedUsers.some((u) => u.userId === userId);
    },
    async handleSelectUser(user) {
      if (this.userPickerVerifyingId) return;
      if (this.isUserConfirmed(user.userId)) {
        this.confirmedUsers = this.confirmedUsers.filter(
          (u) => u.userId !== user.userId
        );
        return;
      }
      this.userPickerVerifyingId = user.userId;
      const res = await this.verifyDepositMatchEligibility(user.userId);
      if (!res || !res.isEligible) {
        this.showToastError("User is not eligible for deposit match.", "Error");
        this.userPickerVerifyingId = null;
        return;
      }
      try {
        this.confirmedUsers = [...this.confirmedUsers, user];
        this.showToastSuccess(
          "success",
          `User "${user.username || user.userId}" added.`
        );
      } catch (e) {
        this.showToastError(false, "Failed to add user.");
      } finally {
        this.userPickerVerifyingId = null;
      }
    },
    removeConfirmedUser(idx) {
      this.confirmedUsers.splice(idx, 1);
    },
    handleAddConfirmedUsersToSegment() {
      if (!this.confirmedUsers.length) return;
      const newSegment = {
        name: "Untitled",
        uuid: uuidv4(),
        selectedUsers: this.confirmedUsers.map((u) => u.userId),
        targetType: "UserList",
        source: "customer",
      };
      this.selectedSegment = [...this.selectedSegment, newSegment];
      this.confirmedUsers = [];
      this.showToastSuccess(
        "success",
        `${newSegment.selectedUsers.length} users added to recurrence list.`
      );
    },
    async createDeposit() {
      try {
        const res = await this.createDepositMatchOffer({
          ...this.form,
          openDate: new Date(this.form.openDate).toISOString(),
          closeDate: new Date(this.form.closeDate).toISOString(),
        });
        if (res) {
          this.showToastSuccess(
            "Create deposit match successfully!",
            "Success"
          );
          this.resetForm();
        }
      } catch (e) {
        this.showToastError("Create deposit match failed!", "Error");
      }
    },
    resetForm() {
      this.form = {
        name: "",
        description: "",
        openDate: "",
        closeDate: "",
        bonusExpiredDays: 5,
        type: "deposit",
        maxDiscount: "",
        discountValue: "",
        activeStatus: "inactive",
        currentResource: null,
        templateId: null,
        termFinalContent: "",
      };
      this.banners.forEach((banner) => {
        banner.file = null;
        banner.previewUrl = null;
        banner.resourceId = null;
      });
      this.formBanner = {
        endDate: "",
        bannerLink: "",
        bannerPosition: "",
        startDate: "",
        endDate: "",
      };
      this.selectedProfile = [];
      this.selectedSegment = [];
    },
    handleSelectProfile(item) {
      if (this.selectedProfile.some((i) => i === item))
        return (this.selectedProfile = this.selectedProfile.filter(
          (i) => i !== item
        ));
      this.selectedProfile = [...this.selectedProfile, item];
    },
    handleDrag(event) {},
    handleDrop(event) {
      const draggedTag = event.clone?.innerText?.trim();
      if (
        !draggedTag ||
        this.selectedSegment.some((i) => i.name === draggedTag)
      )
        return;
      const item = this.customerSegments.find((i) => i.name === draggedTag);
      this.selectedSegment.splice(event.newIndex, 0, {
        ...item,
      });
    },
    async fetchSegmentList() {
      const data = await this.getSegmentsList({
        limit: 100,
      });
      this.customerSegments = data.data.map((i) => {
        return {
          name: i.name,
          id: i.id,
        };
      });
    },
    async fetchProfileList() {
      const data = await this.getProfileList();
      this.profiles = data.map((i) => i.profileTypeId);
    },
    mapBannerForm(data) {
      if (!data) return;
      this.formBanner = {
        ...this.formBanner,
        bannerId: data.bannerId,
        startDate: data.startDate,
        endDate: data.endDate,
        bannerLink: data.bannerLink,
        bannerPosition: data.bannerPosition,
        platform: data.platform,
      };
    },
    mapBannerResource(data) {
      if (!data?.resources?.length) return;
      const index = this.banners.findIndex(
        (b) => b.key === data.bannerPosition
      );
      if (index === -1) return;
      const resource = data.resources[0];
      this.banners[index] = {
        ...this.banners[index],
        resourceId: resource?.resourceId || null,
        previewUrl: resource?.url || null,
      };
      this.form.currentResource = this.banners[index];
    },
    async fetchDetailPromotion() {
      if (!this.$router.currentRoute.params.id) return;
      const { data: data } = await this.getDetailPromotion(
        this.$router.currentRoute.params.id
      );
      this.form = {
        name: data.name,
        description: data.description,
        additionalInfo: data.additionalInfo,
        bonusExpiredDays: data.bonusExpiredDays,
        discountType: "deposit-bonus",
        maxDiscount: data.maxDiscount,
        activeStatus: data.status,
        subType: data.subType,
        discountValue: data.discountValue,
        openDate: data.startTime,
        closeDate: data.endTime,
        currentResource: data.banner ? data.banner?.resources?.[0] : null,
        templateId: data.templateId,
        termFinalContent: data.termFinalContent,
      };
      this.$nextTick(() => {
        this.form.termFinalContent = data.termFinalContent || "";
      });
      if (data.banner) {
        this.mapBannerForm(data.banner);
        this.mapBannerResource(data.banner);
      }
      {
        const targets = data.targets.filter((i) => i.targetType !== "Profile");
        const selectedSegment = [];
        for (const i of targets) {
          if (i.targetType === "CustomerSegment") {
            const item = this.customerSegments.find((r) => r.id === i.targetId);
            if (item) {
              selectedSegment.push(item);
            }
            continue;
          }

          let list;
          if (i.targetType === "UserList") {
            list = await this.fetchUserList(i.targetId);
          }

          selectedSegment.push({
            id: i.targetId,
            ...i,
            name: i.targetType === "User" ? "User" : "Untitled",
            selectedUsers: list,
          });
        }
        this.selectedSegment = selectedSegment;
      }

      this.selectedProfile = data.targets
        .filter((i) => i.targetType === "Profile")
        .map((i) => {
          const item = this.profiles.find((r) => r === i.targetId);
          return item;
        });

      this.selectedPosition = data.rules
        .filter((i) => i.conditionType === "position")
        .map((i) => Number(i.conditionValue));

      this.editData = data;
    },
    async fetchUserList(id) {
      const res = await this.getUserList(id);
      return res.data.map((i) => i.userId);
    },
    async handleCreatePromotion({ status, isNow = false, action }) {
      const valid = await this.$refs.validateDepositMatchForm.validate();
      if (!valid) return;
      this.form.activeStatus = status;
      this.loadingAction = action;
      const isUpdate = !!this.$router.currentRoute.params.id;
      const { currentResource } = this.form;
      const formatSelectedPosition = this.selectedProfile.map((i) => {
        return {
          targetType: "Profile",
          targetId: i,
        };
      });

      const formatSelectedSegment = [];
      for (const i of this.selectedSegment) {
        if (!i.selectedUsers) {
          formatSelectedSegment.push({
            targetType: "CustomerSegment",
            targetId: i.id,
          });
          continue;
        }

        let targetUserListId;
        if (i && i.targetType === "UserList" && !i.targetId) {
          const resListId = await this.createUserList({
            userIds: i.selectedUsers,
          });
          if (resListId && resListId.data) targetUserListId = resListId.data;
        } else if (i.targetType === "UserList" && i.targetId) {
          targetUserListId = i.targetId;
        }

        formatSelectedSegment.push({
          targetType: "UserList",
          targetId: targetUserListId,
        });
      }
      const { startDate, endDate, ...restFormBanner } = this.formBanner;
      const bannerInfo = { ...restFormBanner };
      const newId = this.banners.find(
        (b) => b.key === bannerInfo.bannerPosition
      )?.resourceId;

      if (!isUpdate) {
        bannerInfo.resourceIds = this.banners
          .filter((b) => b.resourceId)
          .map((b) => b.resourceId);
      } else if (newId) {
        const oldId = currentResource?.resourceId;
        if (!oldId) {
          bannerInfo.resourceIds = [newId];
        } else if (oldId !== newId) {
          bannerInfo.resources = [{ oldResourceId: oldId, resourceId: newId }];
        }
      }

      if (startDate && endDate) {
        bannerInfo["startDate"] = this.formatDateSend(startDate);
        bannerInfo["endDate"] = this.formatDateSend(endDate);
        bannerInfo["platform"] = "all";
      }
      const data = sanitizePayload({
        name: this.form.name,
        description: this.form.description,
        additionalInfo: this.form.additionalInfo,
        type: "Deposit",
        subType: this.form.subType,
        discountType: "deposit-bonus",
        discountValue: Number(this.form.discountValue),
        maxDiscount: Number(this.form.maxDiscount),
        status,
        startTime: this.formatDateSend(isNow ? new Date() : this.form.openDate),
        endTime: this.formatDateSend(this.form.closeDate),
        bonusExpiredDays: this.form.bonusExpiredDays,
        bannerInfo,
        templateId: this.form.templateId,
        termFinalContent: this.form.termFinalContent,
      });
      if (isUpdate) {
        await Promise.all([
          this.handleUpdatePromotion(data),
          this.handleUpdatePromotionTargets([
            ...formatSelectedPosition,
            ...formatSelectedSegment,
          ]),
        ]);
        this.showToastSuccess(
          "success",
          "This promotion updated successfully!"
        );
        return;
      }
      const res = await this.createNewPromotion({
        ...data,
        targets: [...formatSelectedPosition, ...formatSelectedSegment],
      });
      if (res.data) {
        this.showToastSuccess("success", "Promotion created successfully!");
        this.$router.push("/promotions/deposit-match");
      }
    },
    async handleUpdatePromotion(data) {
      const res = await this.updatePromotion({
        promotionId: this.$router.currentRoute.params.id,
        ...data,
      });
      return res;
    },
    convertListToIdsTarget(l) {
      return l.reduce((acc, item, index) => {
        const key = `ids[${index}]`;

        acc[key] = item.id;

        return acc;
      }, {});
    },
    async handleUpdatePromotionTargets(list) {
      const resDelete = await this.deletePromotionTarget(
        this.convertListToIdsTarget(this.editData.targets)
      );
      if (!resDelete) return;
      const res = await this.updatePromotionTargets({
        promotionId: this.$router.currentRoute.params.id,
        targets: list,
      });
      return res;
    },
    onClickInput() {
      const fileInput = this.$refs.fileInput;
      fileInput.click();
    },
    _resetInputFile() {
      this.$refs.fileInput.value = null;
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.parseCSV(reader.result);
      };
      reader.readAsText(file);
      this._resetInputFile();
    },
    parseCSV(csvData) {
      parse(csvData, { delimiter: "," }, (err, data) => {
        if (err) {
          console.error(err);
          return;
        }
        data.shift();
        const newList = data.map((i) => i[0]);

        if (newList.length > 0) {
          this.selectedSegment = [
            ...this.selectedSegment,
            {
              name: "Untitled",
              id: uuidv4(),
              targetType: "UserList",
              selectedUsers: newList,
            },
          ];
          this.activeTabCustomer = "Customer Segments";
        }
      });
    },
    deleteSegmentItem(item) {
      this.selectedSegment = this.selectedSegment.filter(
        (i) => i.id !== item.id
      );
    },
    async onFileChange(banner) {
      if (!banner.file) return;
      try {
        this.formBanner.bannerPosition = banner.key;
        banner.loading = true;
        const result = await this.uploadBannerImage(banner);
        banner.previewUrl = result[0].url;
        banner.resourceId = result[0].resourceId;
        banner.loading = false;
      } catch (error) {
        banner.loading = false;
      }
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();
    return {
      showToastError,
      showToastSuccess,
      formatDateSend,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
.grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.active-tab {
  color: #0d6efd;
  border: 1px solid #dee2e6;
  border-radius: 5px 5px 0 0;
  border-bottom: 1px solid #0d6efd;
}

.active-position {
  background: #0d6efd;
  color: white;
}
</style>